import React, { useState } from 'react';
import { Flex, Text, Box, Image } from 'rebass';
import { Page } from 'react-pdf';
import styled from 'styled-components';
import closeIcon from '../../assets/icons/close.png';
import PaginationButton from './PaginationButton';

const StyledPage = styled(Page)<{ isHidden: boolean }>`
  display: ${props => (props.isHidden ? 'none' : 'block')};
`;

interface AllPDFPagesProps {
  closeModalHandler: VoidFunction;
  pageAmount: number;
}

const AllPDFPages: React.FC<AllPDFPagesProps> = ({ pageAmount, closeModalHandler }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLoadingStatus, setPageLoadingStatus] = useState(false);

  return (
    <Box>
      {pageLoadingStatus && (
        <Flex margin="3%" justifyContent="flex-end" onClick={closeModalHandler}>
          <Image src={closeIcon} css="cursor: pointer" />
        </Flex>
      )}
      {Array.from(new Array(pageAmount), (el, index: number) => (
        <StyledPage
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          loading={<div style={{ margin: '300px 300px' }}>Loading...</div>}
          onLoadSuccess={() => setPageLoadingStatus(true)}
          renderTextLayer={false}
          isHidden={index + 1 !== pageNumber}
        />
      ))}
      {pageLoadingStatus && (
        <Flex justifyContent="center" margin="10px auto" css={{ userSelect: 'none' }}>
          {pageNumber > 1 && (
            <PaginationButton
              buttonHandler={() => setPageNumber(pageNumber - 1)}
              label="previous"
            />
          )}
          <Text fontWeight="bold" margin="0 5%">
            {pageNumber}
          </Text>
          {pageNumber !== pageAmount && (
            <PaginationButton buttonHandler={() => setPageNumber(pageNumber + 1)} label="next" />
          )}
        </Flex>
      )}
    </Box>
  );
};

export default AllPDFPages;
